module.exports = __webpack_public_path__ + "img/Jagadish.22cb6b95.jpg";